[
  {
    "id": 4903,
    "uuid": "bd226bc4-4f88-42e0-a421-18fe06b0564d",
    "hitokoto": "你总会遇到一个人 恰如其分的适合你 不用刻意迁就，任意撒娇，你们相爱，并且默契。",
    "type": "j",
    "from": "网易云热评",
    "from_who": "相爱十年",
    "creator": "QIQI",
    "creator_uid": 494,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1574512325",
    "length": 40
  },
  {
    "id": 4905,
    "uuid": "59359c1b-1d1f-47bb-8c79-67599d7dee48",
    "hitokoto": "一旬败给年少轻狂的理想，二旬败给青涩无知的爱情，三旬败给沧桑寂寥的现实。",
    "type": "j",
    "from": "网易云热评",
    "from_who": "理想三旬",
    "creator": "卿书",
    "creator_uid": 4289,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1573825095",
    "length": 36
  },
  {
    "id": 4981,
    "uuid": "7d23ea19-b8d9-4b08-ac03-ca28613e5ecb",
    "hitokoto": "冲动的红色终究是败在了白玫瑰的平淡和冷静上，狠狠的跌了一个大跟头，看着更加刺眼。",
    "type": "j",
    "from": "红玫瑰和白玫瑰",
    "from_who": null,
    "creator": "我爱的曾经",
    "creator_uid": 4897,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581589896",
    "length": 40
  },
  {
    "id": 5071,
    "uuid": "83b37c46-f6b0-4c18-984a-0f269fea81e4",
    "hitokoto": "如果忘记你那么容易，那我爱你干嘛！",
    "type": "j",
    "from": "原创",
    "from_who": null,
    "creator": "赵西湘",
    "creator_uid": 4950,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1581866804",
    "length": 17
  },
  {
    "id": 5108,
    "uuid": "a9f006a9-8af6-4f2b-a4d7-03f50c70ffd6",
    "hitokoto": "多巴胺不等于爱情，爱情却一定有多巴胺！",
    "type": "j",
    "from": "网易热评",
    "from_who": "不在爱里迷失",
    "creator": "小忧忧",
    "creator_uid": 4701,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582646685",
    "length": 19
  },
  {
    "id": 5109,
    "uuid": "0b9533fc-3850-43f6-bb03-423a5dbf2fa5",
    "hitokoto": "荷尔蒙决定一见钟情，多巴胺决定天长地久。",
    "type": "j",
    "from": "网易云",
    "from_who": "不自爱里迷失",
    "creator": "小忧忧",
    "creator_uid": 4701,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582646766",
    "length": 20
  },
  {
    "id": 5116,
    "uuid": "638b83e6-88d1-4499-a091-b9569f53dc14",
    "hitokoto": "要保持希望在每天清晨太阳升起。",
    "type": "j",
    "from": "自己",
    "from_who": null,
    "creator": "惜于顾",
    "creator_uid": 4929,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581739852",
    "length": 15
  },
  {
    "id": 5165,
    "uuid": "cc5d4eca-b4fb-4da8-aa1c-7f69d8cea9fb",
    "hitokoto": "恰沐春风共同游，终只叹，木已舟。",
    "type": "j",
    "from": "网易云",
    "from_who": null,
    "creator": "悬日",
    "creator_uid": 5126,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1582871417",
    "length": 16
  },
  {
    "id": 5209,
    "uuid": "abb4784d-5790-4c1b-be3f-b23025fd69a6",
    "hitokoto": "因为痛苦太有价值，因为回忆太珍贵，所以我们更要继续往前走。",
    "type": "j",
    "from": "五月天",
    "from_who": null,
    "creator": "MayDay",
    "creator_uid": 5129,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583345015",
    "length": 29
  },
  {
    "id": 5229,
    "uuid": "e50068ca-c13b-4f28-a9ee-0e53d6776b10",
    "hitokoto": "所谓有趣的灵魂，实际上就是这个人的信息密度和知识层面，都远高于你，并愿意俯下身去听你说那毫无营养的废话和你交流，提出一些你没有听过的观点，颠覆了你短浅的想象力及三观。",
    "type": "j",
    "from": "网易云音乐",
    "from_who": null,
    "creator": "Miko",
    "creator_uid": 5305,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583727209",
    "length": 83
  },
  {
    "id": 5311,
    "uuid": "a316bec6-0f9d-4c66-a3d2-6dda48588ca9",
    "hitokoto": "私は 根拠も 証明も ないような 現状世界くらいがお似合いだ。",
    "type": "j",
    "from": "ライラック",
    "from_who": "美博",
    "creator": "dd斩首",
    "creator_uid": 5577,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1584884275",
    "length": 31
  },
  {
    "id": 5312,
    "uuid": "8f7adef7-d229-468e-bb47-8732f0db98d3",
    "hitokoto": "人のエゴで造られた 虚にだけはなりたくはなくて。",
    "type": "j",
    "from": "ライラック",
    "from_who": "美波",
    "creator": "dd斩首",
    "creator_uid": 5577,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1584884340",
    "length": 24
  },
  {
    "id": 5324,
    "uuid": "4b01d901-0574-4dab-afa8-215cf5c82db6",
    "hitokoto": "我们总是喜欢拿“顺其自然”来敷衍人生道路上的荆棘坎坷，却很少承认，真正的顺其自然，其实是竭尽所能之后的不强求，而非两手一摊的不作为。",
    "type": "j",
    "from": "网易云 花びらの刻",
    "from_who": null,
    "creator": "莽红尘觅知嘤",
    "creator_uid": 5611,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585216455",
    "length": 66
  },
  {
    "id": 5342,
    "uuid": "47ec2535-2384-4bee-b3b7-b4879bdcc182",
    "hitokoto": "愿生活不太拥挤，愿笑容不必刻意。愿孤独不再长久，愿碎镜终有重圆。",
    "type": "j",
    "from": "网易云音乐",
    "from_who": "风来了呀_",
    "creator": "lzt",
    "creator_uid": 5623,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1585139991",
    "length": 32
  },
  {
    "id": 5960,
    "uuid": "46f53268-b0ac-4921-a49a-53bcfd935bc3",
    "hitokoto": "就像那句狠话：有一天，我一定会后悔的。",
    "type": "j",
    "from": "网易云",
    "from_who": "此账号已注销",
    "creator": "破晓之雪",
    "creator_uid": 5882,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586821497",
    "length": 19
  },
  {
    "id": 5967,
    "uuid": "bad64921-c8b6-433f-b058-8120906eeef2",
    "hitokoto": "世界之大为何我们相遇，难道是缘分，难道是天意。",
    "type": "j",
    "from": "我的歌声里",
    "from_who": "曲婉婷",
    "creator": "陈树凤",
    "creator_uid": 5678,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1587181370",
    "length": 23
  },
  {
    "id": 6054,
    "uuid": "36d1f4a5-2a34-4489-b776-f2857c8baf47",
    "hitokoto": "想一个人有多想念，那又是文字失效瞬间。",
    "type": "j",
    "from": "仓颉",
    "from_who": "五月天",
    "creator": "小杨",
    "creator_uid": 5943,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587639189",
    "length": 19
  },
  {
    "id": 6063,
    "uuid": "5022c874-6065-4dab-8cca-576e584f5e37",
    "hitokoto": "“浪漫”源于骑士文学，形容中世纪骑士阶级和贵妇人之间注定无法有结果的爱情；“Romance”的本意就是知其不可而为之,是明知不会有结果却无法停止爱你。",
    "type": "j",
    "from": "网易云",
    "from_who": "此账号已注销",
    "creator": "破晓之雪",
    "creator_uid": 5882,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587877950",
    "length": 75
  },
  {
    "id": 6064,
    "uuid": "102e669d-3f7a-49e3-88e3-5a571756c747",
    "hitokoto": "让我们惊艳过的星辰，流淌在失眠的音阶，落足仲夏的暗沉之夜，蚊虫都进化成坦然的旅客。未结清的烂账堆满前半生，旅馆的钨丝灯阔然开朗，我惊恐的闭上双眼，从此再没有睁开。",
    "type": "j",
    "from": "网易云",
    "from_who": "unlighted",
    "creator": "破晓之雪",
    "creator_uid": 5882,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587878094",
    "length": 81
  },
  {
    "id": 6065,
    "uuid": "44931e26-6f34-4ebb-9217-9f193d2858fc",
    "hitokoto": "——什么是孤独？——心里明明空荡荡的，却什么也装不下。",
    "type": "j",
    "from": "网易云",
    "from_who": "此账号已注销",
    "creator": "破晓之雪",
    "creator_uid": 5882,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587878121",
    "length": 27
  },
  {
    "id": 6091,
    "uuid": "4e25fa6a-35f7-450d-8381-5f087c9d4e43",
    "hitokoto": "隔着屏幕轻易产生感情的你，肯定很孤独吧。",
    "type": "j",
    "from": "you're somebody else",
    "from_who": null,
    "creator": "xiaoz",
    "creator_uid": 6104,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588497019",
    "length": 20
  },
  {
    "id": 6126,
    "uuid": "fe327dae-bbf7-49f4-9684-1f31897b4a5f",
    "hitokoto": "流萤漫天花共舞，闲蝉栖柳风奏湖。十年一梦不觉醒，夏祭花火终成空。",
    "type": "j",
    "from": "夏祭り、夢花火",
    "from_who": "旋土浮尘",
    "creator": "Liak",
    "creator_uid": 6141,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588760942",
    "length": 32
  },
  {
    "id": 6128,
    "uuid": "7257297b-5995-4506-adf9-efa24f6abb2b",
    "hitokoto": "幽幽轻音入梦来，淡淡忧伤曲中闻。似乐又皮更轻音，原是梦入幻想乡。",
    "type": "j",
    "from": "蓬莱传说（蓬莱伝説）",
    "from_who": "千茗猫",
    "creator": "Liak",
    "creator_uid": 6141,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588772123",
    "length": 32
  },
  {
    "id": 6136,
    "uuid": "19b6b09d-b85f-40ac-b4b8-6601b34c464b",
    "hitokoto": "Grab the air, We can try to fly. 抓住空气我们可以尝试飞翔。",
    "type": "j",
    "from": "Grab the air",
    "from_who": "milet",
    "creator": "dd斩首",
    "creator_uid": 5577,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591522114",
    "length": 46
  },
  {
    "id": 6148,
    "uuid": "9cf55246-80d0-452a-938e-f8dc136e5d58",
    "hitokoto": "See I was blind to the sun by my thunder.",
    "type": "j",
    "from": "I Feel Human",
    "from_who": "Vicetone",
    "creator": "foreversama",
    "creator_uid": 3576,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589112295",
    "length": 41
  },
  {
    "id": 6182,
    "uuid": "cd536441-c25d-4091-9b9e-40ca2e189ef5",
    "hitokoto": "每个人的心里，都有一个忘不记，却无法拥抱珍惜的人。",
    "type": "j",
    "from": "热评",
    "from_who": null,
    "creator": "青羊",
    "creator_uid": 6284,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590349622",
    "length": 25
  },
  {
    "id": 6212,
    "uuid": "e4c6a54a-be51-4cdd-88ab-3df273dbaa87",
    "hitokoto": "在不同的遭遇里我发现你的瞬间，有种不可言说的温柔直觉。",
    "type": "j",
    "from": "保留",
    "from_who": "郭顶",
    "creator": "陨星、若芜芫",
    "creator_uid": 6317,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590718236",
    "length": 27
  },
  {
    "id": 6259,
    "uuid": "874496cc-f3f9-4c5f-bab8-4cc290d6a99d",
    "hitokoto": "真正走掉那次，关门声最小。",
    "type": "j",
    "from": "网易云",
    "from_who": "@-南得你-",
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592125903",
    "length": 13
  },
  {
    "id": 6339,
    "uuid": "3fb5d9e3-548e-4161-ae4d-1c8e6283bf0a",
    "hitokoto": "有的人，终生都在怀念那个夏天。最好的我们，始终会留在那年八月。前程似锦是一句离别时说的话 ，祝你前程似锦也祝我前途无量。这首歌的评论刷的这么快，就让这条评论，带着我对你祝福沉下去吧。",
    "type": "j",
    "from": "网易云热评",
    "from_who": null,
    "creator": "HuiGuo",
    "creator_uid": 6591,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593434605",
    "length": 91
  },
  {
    "id": 6379,
    "uuid": "210abe14-2bd9-483a-9d49-216dd8e28701",
    "hitokoto": "得你一个，不要花火，无需经历从未遗憾过，冒险生活从未适合我，得你得我若无其事渡过，难得的是你不讨厌我。",
    "type": "j",
    "from": "我得你",
    "from_who": "张学友",
    "creator": "PaulWong",
    "creator_uid": 6535,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1595523386",
    "length": 51
  },
  {
    "id": 6396,
    "uuid": "b45da923-686d-45cb-8343-a4b53b44d607",
    "hitokoto": "你是否真的可以feel my pain，还是你和他们一样都会变。",
    "type": "j",
    "from": "intro-我",
    "from_who": "泥鳅",
    "creator": "你有多久没有看过星星",
    "creator_uid": 6840,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596107216",
    "length": 32
  },
  {
    "id": 6457,
    "uuid": "0e763da0-7eda-431f-9712-0accf900edb9",
    "hitokoto": "我希望兜兜转转之后那个人还是你.",
    "type": "j",
    "from": "网易云音乐",
    "from_who": "不要半夜躲在被子里哭了",
    "creator": "VenomSnake",
    "creator_uid": 7323,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1601639030",
    "length": 16
  },
  {
    "id": 6527,
    "uuid": "fddf5bb3-f3ec-499b-b637-0ea093250c76",
    "hitokoto": "哪有顷刻之间的心灰意冷，有的，只是日积月累的看透罢了。",
    "type": "j",
    "from": "觅楽-语录",
    "from_who": "觅楽",
    "creator": "悟空",
    "creator_uid": 7256,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1601175266",
    "length": 27
  },
  {
    "id": 6611,
    "uuid": "b00dd7cf-2ed5-4458-b96c-f5f620822ed6",
    "hitokoto": "无论在什么时候，在这世间的角落都会有一些人逆着光而来，将温暖洒落人间。",
    "type": "j",
    "from": "网易云音乐",
    "from_who": "网友",
    "creator": "Tesla",
    "creator_uid": 7585,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603885340",
    "length": 35
  },
  {
    "id": 6686,
    "uuid": "ad547d28-109c-408d-bb71-099ac786f125",
    "hitokoto": "来人间一趟 你要看看太阳。",
    "type": "j",
    "from": "海底",
    "from_who": "薯味博饼",
    "creator": "fengbujue",
    "creator_uid": 7736,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605261525",
    "length": 13
  },
  {
    "id": 6714,
    "uuid": "0167e1d0-02f7-4399-9a56-0631b307fad0",
    "hitokoto": "她去世时，自己并没有想象中那么悲伤，只是感到很失落。现在才知道，原来是那份悲伤被分散到我的整个余生了。",
    "type": "j",
    "from": "网易云",
    "from_who": "@LeePlusPlus",
    "creator": "Irony",
    "creator_uid": 4464,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605011811",
    "length": 51
  },
  {
    "id": 6740,
    "uuid": "fa5dc1da-4765-4b80-92fa-ad5303481856",
    "hitokoto": "我在最没有能力的年纪，遇见了最想照顾一生的人。",
    "type": "j",
    "from": "网易云音乐",
    "from_who": null,
    "creator": "小透明",
    "creator_uid": 7788,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605768847",
    "length": 23
  },
  {
    "id": 6786,
    "uuid": "3d26c536-37c5-40e0-8db5-03fc069cf28e",
    "hitokoto": "人与人的相遇，不是恩赐就是劫。",
    "type": "j",
    "from": "网易云",
    "from_who": "ShimmerLS",
    "creator": "ShimmerLS",
    "creator_uid": 7868,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606420861",
    "length": 15
  },
  {
    "id": 6834,
    "uuid": "2ffb27d4-a24c-48cc-bd17-acb575fe2712",
    "hitokoto": "我有故人抱剑去，斩尽春风未曾归。",
    "type": "j",
    "from": "孤山不孤",
    "from_who": "鸾歌",
    "creator": "Yousazoe",
    "creator_uid": 7945,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607219032",
    "length": 16
  },
  {
    "id": 6894,
    "uuid": "55eb86a8-b0e5-4e35-986d-45db57c48b19",
    "hitokoto": "成熟的人眼里满是前途，稚嫩的人眼里满是爱恨情仇。",
    "type": "j",
    "from": "网易云热评",
    "from_who": null,
    "creator": "星空下的约定",
    "creator_uid": 7959,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607433993",
    "length": 24
  },
  {
    "id": 6984,
    "uuid": "7a83ff07-faf8-4d14-b0cc-efaf296ecadb",
    "hitokoto": "搞怪的不是红绿灯，而是我数不清的犹豫。",
    "type": "j",
    "from": "请回答1998",
    "from_who": null,
    "creator": "情话.",
    "creator_uid": 7164,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611794293",
    "length": 19
  },
  {
    "id": 7126,
    "uuid": "b89d162c-e3aa-412a-aaac-ff19aa0cb3a6",
    "hitokoto": "我也想杀死伤痛，让那恩怨有始有终。",
    "type": "j",
    "from": "县城",
    "from_who": "刘森",
    "creator": "Hacbox",
    "creator_uid": 8608,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1616907034",
    "length": 17
  },
  {
    "id": 7311,
    "uuid": "9a17c193-9922-4bce-baea-d4c27caf17cc",
    "hitokoto": "有些人光是遇到就已经赚到了。",
    "type": "j",
    "from": "网易云",
    "from_who": "赵紫骅",
    "creator": "James",
    "creator_uid": 9109,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1619272123",
    "length": 14
  },
  {
    "id": 7362,
    "uuid": "54f7cf49-b228-428c-8ef9-f12e0e2eb2df",
    "hitokoto": "人间忽晚，山河已秋。",
    "type": "j",
    "from": "人间忽晚",
    "from_who": "亦沫不吃鱼",
    "creator": "GL",
    "creator_uid": 9589,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1624861348",
    "length": 10
  },
  {
    "id": 7368,
    "uuid": "02843d42-4018-4e3c-811a-f86332508d04",
    "hitokoto": "我喝过你喝的西北风，这算不算很穷。",
    "type": "j",
    "from": "网易云",
    "from_who": "妤儿_moon",
    "creator": "cookie1038",
    "creator_uid": 9607,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1625134833",
    "length": 17
  },
  {
    "id": 7437,
    "uuid": "b4b49262-8ad0-4ad6-a30d-9463c16245aa",
    "hitokoto": "抽烟的人永远闻不到身上的烟味，就像被爱的人，永远不知道爱他的人有多累。",
    "type": "j",
    "from": "网易云",
    "from_who": "James",
    "creator": "James",
    "creator_uid": 9109,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619272172",
    "length": 35
  },
  {
    "id": 7512,
    "uuid": "40797401-d20f-4160-b61d-758e833db0d5",
    "hitokoto": "停下脚步才注意到 世界被染得雪白。",
    "type": "j",
    "from": "雪降り、メリクリ",
    "from_who": "A39＆沙包P＆初音ミク",
    "creator": "hbyang233",
    "creator_uid": 10440,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1632098732",
    "length": 17
  }
]